import React, { useState } from "react";
import "../src/styles/SignIn.scss";
import "../src/styles/CommonStyle.scss";
import "../src/MediaFiles/Media.scss";
import { Link, useNavigate } from "react-router-dom";
import { baseURL } from "./Components/BaseUrl";
import { Button, Col, Image, Row, Carousel } from "react-bootstrap";
import travelize from "./images/metric-favicon.svg";
import travelizeSalesBeeLogo from "./images/MatricLogo.svg";
import InternetIssue from "./Components/InternetIssue";
import { toast } from "react-toastify";
import * as HeaderAuthentication from "../src/Components/HeaderAuthentication";
import { useDispatch } from "react-redux";
import { loadGetOTP } from "./redux/action";
// import OtpVerification from "./OtpVerification";

const SignIn = () => {
  let themeColor = localStorage.getItem("theme");

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loginStatus, setLoginStatus] = useState("");
  const [loginResponse, setLoginResponse] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  let navigate = useNavigate();

  const [passwordType, setPasswordType] = useState("password");

  const togglePassword = () => {
    if (passwordType === "password") {
      setPasswordType("text");
      return;
    }
    setPasswordType("password");
  };

  const navigateToDashboard = () => {
    window.location.href = "/";
  };

  const loginValidation = (e) => {
    if (email && password) {
      const userNamePassword = {
        UserName: email,
        Password: password,
      };
      let requestoption = {
        method: "POST",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(userNamePassword),
      };
      fetch(`${baseURL}/api/Authentication/Login`, requestoption)
        .then((res) => res.json())
        .then((res) => {
          if (res.success) {
            // if (password.includes("MetricInfo_")) {
            //   navigate("/changePassword");
            // } else {
            // setLoginResponse(res.success);
            toast.success(`Login ${res.message}`);
            setLoginStatus(`Login ${res.message}`);
            sessionStorage.setItem("usdtls", JSON.stringify(res.result));

            //// CHECK SUBSCRIPTION EXPIRY
            let requestOptionS = {
              method: "GET",
              mode: "cors",
              headers: {
                "Content-Type": "application/json",
                Accept: "application/json",
                Travelize_Authentication: res.result,
              },
            };
            fetch(
              `${baseURL}/api/DashBoard/GetLoginUserDetails`,
              requestOptionS
            )
              .then((res) => res.json())
              .then((res) => {
                const subscriptionExpiry = res?.result?.subscription?.daysleft;
                if (subscriptionExpiry == 0) {
                  navigate("/subscriptionexpiry");
                } else {
                  const userLoginDetails = res.result;
                  sessionStorage.setItem("loginId", userLoginDetails.userId);
                  sessionStorage.setItem(
                    "usrlgndtls",
                    JSON.stringify(userLoginDetails)
                  );
                  if (
                    userLoginDetails?.desingation?.role?.roleName == "Admin" &&
                    userLoginDetails?.subscriptionId == "SUB0000000001"
                  ) {
                    sessionStorage.setItem("AdminRole", true);
                  }
                  if (
                    userLoginDetails?.desingation?.role?.roleName == "Admin"
                  ) {
                    sessionStorage.setItem("AdminAccess", true);
                  }
                  if (
                    userLoginDetails?.desingation?.role?.roleName == "Manager"
                  ) {
                    sessionStorage.setItem("ManagerAccess", true);
                  }
                  if (!themeColor) {
                    localStorage.setItem("theme", "light");
                  }
                  // navigateToDashboard();
                  // Check if password contains "MetricInfo_"
                  navigateToDashboard();
                }
              })
              .catch((error) => {
                console.log("ERROR :", error);
                setErrorMessage(error.message);
              });
            // }
          } else {
            console.log(res, "res.errorMessage");
            // setLoginResponse(res.success);
            toast.error(res.errorMessage);
            // setLoginStatus(res.errorMessage);
          }
        })
        .catch((error) => {
          console.log("ERROR :", error);
          setErrorMessage(error.message);
        });
    } else {
      // setLoginStatus("Username/Password should not be empty!");
      toast.error("Username/Password should not be empty!");
    }
    e.preventDefault();
  };

  const [isValidEmail, setIsValidEmail] = useState(false);

  const handleEmailChange = (e) => {
    setEmail(e.target.value);
    setIsValidEmail(validateEmail(e.target.value));
  };

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  let dispatch = useDispatch();

  const getOtpForSuperAdmin = () => {
    // setOtpStatus(true);
    // setShowTimer(true);
    // setExpireTime(30)
    var request = {
      userName: email,
    };
    let postRequest = {
      method: "POST",
      mode: "cors",
      headers: HeaderAuthentication.postTravelizeAuth,
      body: JSON.stringify(request),
    };
    dispatch(loadGetOTP(postRequest));
  };

  const navigateToOtp = () => {
    getOtpForSuperAdmin();
    navigate("/otpVerification", { state: { email } });
  };

  return (
    <div>
      {errorMessage ? (
        <InternetIssue />
      ) : (
        <>
          <div className="container-fluid">
            <div className="sigin-page-body">
              {/* <Row> */}
              <div className="dflex-flow-row">
                <Col
                  lg={5}
                  md={5}
                  sm={12}
                  className="signIn-container-left-div"
                >
                  <div className="signIn-container-logo">
                    <Image
                      src={travelizeSalesBeeLogo}
                      alt="MetricInfo"
                      className="signIn-logo"
                    />
                  </div>
                  <div className="signIn-container-gif">
                    <Image
                      src="../images/sign-animate.gif"
                      alt="MetricInfo Motion Logo"
                      className="signIn-moving-img"
                    />
                    <div className="text-sliding-below-img">
                      <Carousel
                        style={{ width: "100%" }}
                        controls={false}
                        indicators={false}
                        interval={3000}
                      >
                        <Carousel.Item>
                          <h6>
                            <b>Geolocation Monitoring</b>
                          </h6>
                          <p>
                            Real-time tracking to determine precise location
                          </p>
                        </Carousel.Item>
                        <Carousel.Item>
                          <h6>
                            <b>Reporting and Analytics</b>
                          </h6>
                          <p>
                            Offering valuable insights for informed
                            decision-making
                          </p>
                        </Carousel.Item>
                        <Carousel.Item>
                          <h6>
                            <b>Visits and Expenses</b>
                          </h6>
                          <p>
                            Ensuring optimal resource allocation
                            and cost control
                          </p>
                        </Carousel.Item>
                      </Carousel>
                    </div>
                  </div>
                </Col>
                <Col lg={2} md={2} sm={12}>
                  <div className="devider">
                    <div className="v1"></div>
                  </div>
                </Col>
                <Col
                  lg={5}
                  md={5}
                  sm={12}
                  className="signIn-container-right-div"
                >
                  <div className="metricinfo-logo">
                    <Image
                      src={travelize}
                      alt="MetricInfo Logo"
                      className="sb-trv-logo"
                    />
                  </div>
                  <div className="signin-header login-part">
                    <div className="signin-box">
                      <div className="login-header-part">
                        <h2 className="mb-1">Welcome back!</h2>
                        <h4>Please sign in to continue</h4>
                      </div>
                      <form
                        onSubmit={loginValidation}
                        className="login-form"
                        autocomplete="off"
                      >
                        <div className="form-group mb20">
                          <div className="icon-with-input before">
                            <i className="fa fa-envelope" />
                            <input
                              type="email"
                              className="form-control signIn-form-control"
                              placeholder="Enter your email"
                              value={email}
                              // onChange={(e) => setEmail(e.target.value)}
                              onChange={handleEmailChange}
                              required
                              maxLength={50}
                            />
                          </div>
                        </div>
                        <div className="form-group">
                          <div className="icon-with-input before">
                            <i className="fa fa-lock"></i>
                            <input
                              type={passwordType}
                              className="form-control signIn-form-control"
                              placeholder="Enter your password"
                              value={password}
                              onChange={(e) => setPassword(e.target.value)}
                              required
                              maxLength={20}
                              minLength={6}
                            />
                            <div className="pass-hide-show">
                              {passwordType === "password" ? (
                                <i
                                  className="bi bi-eye-slash pass-hide-show"
                                  onClick={togglePassword}
                                />
                              ) : (
                                <i
                                  className="bi bi-eye pass-hide-show"
                                  onClick={togglePassword}
                                />
                              )}
                            </div>
                          </div>
                        </div>
                        <div className="forgot-pass-n-get-otp dflex-j-between">
                          <div className="forget-pasword-div">
                            <Link
                              to="/updatedforgotPassword"
                              className="forgot-pass-text color-yellow"
                            >
                              Forgot Password?
                            </Link>
                          </div>
                          <div className="sign-in--using-otp-div">
                            {/* <Button
                              className={`otp-signin ${
                                !isValidEmail && "disabled"
                              }`}
                              onClick={(e) => navigateToOtp()}
                            >
                              Sign In using OTP
                            </Button> */}
                          </div>
                        </div>

                        <div className="signin-button mb20 hv-center">
                          <Button
                            type="submit"
                            className="btn btn-signin-button"
                          >
                            Sign In
                          </Button>
                        </div>
                        {/* {loginResponse ? (
                        <div align="left" className="p-1">
                          <span className="login-msg success"></span>
                        </div>
                      ) : (
                        <div align="left" className="p-1">
                          <span className="login-msg false">{loginStatus}</span>
                        </div>
                      )} */}
                      </form>

                      <div className="signIn-footer mt20">
                        <div className="create-account-div">
                          New to MetricInfo?&nbsp;
                          <Link
                            to="/signup"
                            className="login-signup-text color-green"
                          >
                            Create an Account
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                </Col>
              </div>
              {/* </Row> */}
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default SignIn;
